export enum ScriptEnvironment {
  AllEnvironments = 'all-environments',
  DevelopmentOnly = 'development-only',
  ProductionOnly = 'production-only',
}
